module.exports = {
  model: { id: '', name: '', identification: '', registration: '', street: '', number: '', district: '', complement: '', state: '', city: '', email: '', phone_number: '', time_intervals: [] },
}
